import type { BannerPreset } from '../types';

export const INTERNAL_BANNER_WIDTH = 1500;
export const INTERNAL_BANNER_HEIGHT = 500;

export const BANNER_PRESETS: BannerPreset[] = [
  { id: 'twitter', name: 'Twitter/X Banner', width: INTERNAL_BANNER_WIDTH, height: INTERNAL_BANNER_HEIGHT },
  { id: 'discord', name: 'Discord Banner', width: 960, height: 540 },
  { id: 'custom', name: 'Custom', width: 1920, height: 1080 },
];

export const DEFAULT_BANNER_PRESET = BANNER_PRESETS[0];

export const MIN_BANNER_DIMENSION = 100;
export const MAX_BANNER_DIMENSION = 4096;
